import axios, { AxiosInstance } from 'axios';
import { getVoiceFallbackClient } from './_shared';

// ── Auth (/api/auth) ──────────────────────────────────────────────────

export type VoiceAuthUser = {
  id: string;
  email: string;
  name?: string;
  role?: string;
  workspace_id?: string;
};

/** `GET /api/auth/me` — current authenticated user. */
export async function fetchAuthMe(axiosInstance?: AxiosInstance): Promise<VoiceAuthUser | null> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<VoiceAuthUser>('/api/auth/me');
  return response.data ?? null;
}
